import * as React from "react";
const NuprexLogoFooter = (props) => (
  <svg
    width={props?.size}
    height={49}
    viewBox="0 0 156 49"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_3_1733)">
      <path
        d="M22.4892 36.2724L7.02447 11.9107V36.2724H0V0H8.00589L22.3806 23.3269V0H29.4593V36.2724H22.4892Z"
        fill="white"
      />
      <path
        d="M49.7727 36.2724V32.5019C47.9561 35.489 45.1789 36.9804 41.4411 36.9804C40.0964 36.9804 38.8727 36.7458 37.766 36.2682C36.6593 35.7948 35.7071 35.1203 34.9053 34.2489C34.1076 33.3733 33.4812 32.3385 33.0259 31.1361C32.5707 29.9337 32.3452 28.5889 32.3452 27.0933V9.39697H39.424V26.004C39.424 29.3556 40.9316 31.0314 43.9427 31.0314C45.7594 31.0314 47.1292 30.4574 48.0521 29.3095C48.9751 28.1616 49.4428 26.6953 49.4428 24.9106V9.39697H56.4673V36.2724H49.7686H49.7727Z"
        fill="white"
      />
      <path
        d="M72.2074 30.9181C76.2751 30.9181 78.3047 28.1488 78.3047 22.6145C78.3047 20.2098 77.741 18.2533 76.6175 16.7409C75.4941 15.2285 74.0408 14.4744 72.2617 14.4744C70.4826 14.4744 69.1295 15.1824 67.9852 16.6069C66.8409 18.0271 66.2688 19.883 66.2688 22.1788C66.2688 28.0064 68.2483 30.9181 72.2032 30.9181H72.2074ZM59.5742 48.9998V9.39678H66.3815L66.4358 12.6729C68.0687 10.0126 70.5578 8.68457 73.8946 8.68457C75.5651 8.68457 77.1187 9.01135 78.5511 9.6691C79.9836 10.3227 81.2114 11.2695 82.2263 12.5096C83.2411 13.7496 84.0429 15.2578 84.6234 17.0426C85.2039 18.8273 85.4963 20.8466 85.4963 23.1047C85.4963 25.145 85.2499 27.0093 84.7612 28.706C84.2726 30.3986 83.5543 31.8649 82.6105 33.105C81.6666 34.3451 80.514 35.3003 79.1525 35.9748C77.7911 36.6493 76.2375 36.9844 74.496 36.9844C71.1926 36.9844 68.5406 35.5809 66.5444 32.7782V49.004H59.5742V48.9998Z"
        fill="white"
      />
      <path
        d="M88.0522 36.2722V9.39678H94.6967V12.6185C95.2772 11.7094 95.8869 10.9972 96.5217 10.486C97.1565 9.97493 97.8122 9.58531 98.4804 9.31299C99.1527 9.04067 99.8335 8.86891 100.523 8.7935C101.212 8.72228 101.922 8.68457 102.648 8.68457H103.575V15.9491C102.924 15.8402 102.268 15.7857 101.617 15.7857C97.2985 15.7857 95.1352 17.9517 95.1352 22.2878V36.2722H88.0564H88.0522Z"
        fill="white"
      />
      <path
        d="M121.541 20.21C121.504 19.2255 121.333 18.3624 121.024 17.6167C120.715 16.871 120.305 16.251 119.8 15.7608C119.29 15.2706 118.71 14.9061 118.058 14.6673C117.407 14.4285 116.735 14.3112 116.045 14.3112C114.63 14.3112 113.406 14.8307 112.37 15.8697C111.335 16.9087 110.746 18.3541 110.6 20.2142H121.546L121.541 20.21ZM110.378 24.6885C110.487 26.7288 111.076 28.3501 112.149 29.5483C113.218 30.7507 114.626 31.3498 116.371 31.3498C117.532 31.3498 118.56 31.0859 119.449 30.558C120.339 30.0301 120.911 29.2928 121.166 28.3459H128.462C127.626 31.1152 126.173 33.2434 124.106 34.7391C122.038 36.2305 119.566 36.9804 116.701 36.9804C107.772 36.9804 103.304 32.0997 103.304 22.3424C103.304 20.2687 103.596 18.3918 104.177 16.716C104.757 15.0402 105.601 13.6032 106.707 12.4008C107.814 11.1985 109.167 10.281 110.763 9.64416C112.358 9.00736 114.191 8.68896 116.263 8.68896C120.401 8.68896 123.534 10.017 125.655 12.6773C127.781 15.3376 128.842 19.3428 128.842 24.6969H110.382L110.378 24.6885Z"
        fill="white"
      />
      <path
        d="M145.689 33.084L147.505 36.2973H156L147.017 22.5852L155.729 9.42188H147.18L142.481 17.8218L145.146 22.5852L142.481 27.3486L145.689 33.084Z"
        fill="white"
      />
      <path
        d="M137.608 33.084L135.791 36.2973H127.292L136.28 22.5852L127.568 9.42188H136.117L143.475 22.5852L137.608 33.084Z"
        fill="white"
      />
      <path
        d="M145.689 33.084L147.505 36.2973H156L147.017 22.5852L155.729 9.42188H147.18L142.481 17.8218L145.146 22.5852L142.481 27.3486L145.689 33.084Z"
        fill="white"
      />
      <path
        d="M137.608 33.084L135.791 36.2973H127.292L136.28 22.5852L127.568 9.42188H136.117L143.475 22.5852L137.608 33.084Z"
        fill="#FF6503"
      />
    </g>
    <defs>
      <clipPath id="clip0_3_1733">
        <rect width={156} height={49} fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default NuprexLogoFooter;
